/**
 * Copy for /talent-pool page.
 * Reference: https://hyred-talent-24.aura.build/
 */
export const talentPoolCopy = {
  meta: {
    title: 'Hyred Talent Matching',
    description:
      'Upload CVmu sekali, kita bantu cariin di partner company terverifikasi. Biar kamu bisa dapet panggilan interview berkali kali.',
  },

  brand: {
    short: 'H',
    name: 'Hyred',
    tag: "HYRED'S TALENT MATCHING",
  },

  hero: {
    heading: 'Dicariin Kerja Lewat',
    highlight: "Hyred's Talent Matching",
    description:
      'Upload CVmu sekali, kita bantu cariin di partner company terverifikasi. Biar kamu bisa dapet panggilan interview berkali kali.',
    benefits: ['Gak Pake Bayar', 'Gak Ribet Cari Lowongan'] as const,
  },

  landing: {
    navLinks: [
      { href: '#cara-kerja', label: 'Cara Kerja' },
      { href: '#keamanan', label: 'Keamanan' },
      { href: '#faq', label: 'FAQ' },
    ] as const,
    navUploadButton: 'Upload CV',

    howItWorksTitle: 'Gimana Cara Kerjanya?',
    howItWorksDescription:
      'Bukan magic, tapi sistem pinter yang bikin hidup kamu gampang.',
    howItWorksSteps: [
      {
        number: '1',
        title: 'Upload CV Sekali Aja',
        description:
          'Gak perlu isi form panjang. Cukup upload CV terbaikmu, biar AI kita yang kerja ekstra.',
      },
      {
        number: '2',
        title: 'Profil Jadi "Glowing"',
        description:
          'Sistem merapikan data (skill, tools) jadi profil profesional standar recruiter.',
      },
      {
        number: '3',
        title: 'Matching Otomatis',
        description:
          'Profil "terbang" ke dashboard partner recruiter terverifikasi yang cari skill kamu.',
      },
      {
        number: '4',
        title: 'Lo Pegang Kendali',
        description:
          'Recruiter kirim request. Kamu bisa Terima buat interview, atau Tolak. Simple.',
      },
    ] as const,
    howItWorksCta: 'Mulai Upload CV',

    security: {
      title: 'Privasi Aman,',
      titleHighlight: 'Hati Tenang.',
      features: [
        {
          title: 'Ghost Mode',
          description:
            'Identitas kamu baru kebuka setelah kamu kasih izin "YES".',
        },
        {
          title: 'Verified Only',
          description:
            'Kita cuma kerja sama perusahaan yang ada kantor dan legalitasnya.',
        },
        {
          title: 'Control Panel',
          description: 'Hapus data atau matiin profil kapanpun. Permanen.',
        },
      ] as const,
      panel: {
        status: 'STATUS: GHOST MODE ON',
        rows: [
          { label: 'Name:', value: 'John Doe', hidden: true },
          { label: 'Email:', value: 'john@gmail.com', hidden: true },
          { label: 'Phone:', value: '+62 812 0000', hidden: true },
          { label: 'Skills:', value: 'React, Node.js (Visible)', hidden: false },
        ] as const,
      },
    },

    recruiter: {
      title: 'Intip Dashboard Recruiter',
      description:
        'Ini yang dilihat perusahaan sebelum kamu accept request mereka.',
      canSeeTitle: 'Recruiter Bisa Liat',
      canSee: [
        'Summary Karir & Pencapaian',
        'Tech Stack & Skill Utama',
        'Industri yang Dikuasai',
        'Skor Kecocokan sama Job',
      ] as const,
      canNotSeeTitle: 'Recruiter GAK BISA Liat',
      canNotSee: [
        'Nama Lengkap Kamu',
        'Alamat Rumah (Cuma Kota)',
        'Email & Nomor WhatsApp',
        'Foto Profil',
      ] as const,
    },

    perksTitle: 'Kenapa Harus Hyred?',
    perks: [
      {
        title: 'Peluang Datang Sendiri',
        description:
          'Mending 100 perusahaan yang liat profil kamu daripada capek apply satu-satu.',
      },
      {
        title: 'Hemat Waktu',
        description:
          'Gak perlu pantengin job board. Biar sistem kita jadi "asisten" kamu.',
      },
      {
        title: 'Filter Kualitas',
        description:
          'Kita cuma nyariin lowongan yang match skill kamu, bukan asal lowongan.',
      },
      {
        title: 'Gratis Selamanya',
        description: 'Gak ada potongan gaji atau biaya admin di awal/akhir.',
      },
    ] as const,

    faqTitle: 'FAQ',
    faqItems: [
      {
        question: 'Beneran gratis?',
        answer:
          'Iya, serius. Hyred dapet komisi dari perusahaan partner, bukan dari kamu. 100% Gratis buat talent.',
      },
      {
        question: 'Gimana kalau aku nolak request recruiter?',
        answer:
          'Ya gapapa. Gak ada pinalti, gak ada drama. Kita bakal cariin match yang lain buat kamu.',
      },
      {
        question: 'Bisa buat semua jenis pekerjaan?',
        answer:
          'Saat ini fokus kita ke partner di bidang Tech, Kreatif, dan Profesional Services.',
      },
      {
        question: 'Berapa lama dataku disimpan?',
        answer:
          'Sampai kamu yang mutusin buat hapus. Kami patuh sama aturan perlindungan data.',
      },
    ] as const,

    finalCtaTitleLineOne: 'Siap Dapet Interview Tanpa',
    finalCtaTitleLineTwo: 'Apply Berkali-kali?',
    finalCtaDescription:
      'Tiap minggu kamu apply satu-satu, kandidat lain keduluan dilirik. Luangin 1 menit upload CV, biar perusahaan yang nyamperin kamu.',
    finalCtaButton: 'Mulai Upload CV',
  },

  upload: {
    label: 'Klik untuk upload CV atau drag and drop',
    hint: 'Support: PDF only (Max 5MB)',
    ready: 'Status: Siap di-upload',
    changeFile: 'Ganti file',
  },

  steps: {
    info: 'Info',
    preferences: 'Preferensi',
    submit: 'Submit',
  },

  personal: {
    title: 'Siapa kamu?',
    subtitle: 'Mari mulai dengan data dasar untuk membuat profilmu.',
    fields: {
      fullName: {
        label: 'Nama Lengkap *',
        placeholder: 'John Doe',
      },
      emailAddress: {
        label: 'Email Address *',
        placeholder: 'jane@email.com',
      },
      phoneNumber: {
        label: 'Nomor Telepon *',
        placeholder: '+62 812 3456 7890',
      },
      birthDate: {
        label: 'Birth Date *',
        placeholder: 'Pilih tanggal lahir',
      },
    },
  },

  preferences: {
    title: 'Preferensi',
    fields: {
      targetedRoles: {
        label: 'Role yang Diminati *',
        placeholder: 'Ketik role dan tekan Enter atau koma',
        hint: 'Pisahkan beberapa role dengan Enter atau koma',
      },
      expectedSalaryRange: {
        label: 'Ekspektasi Gaji *',
        placeholder: 'cth: Rp 8.000.000',
      },
      currentCity: {
        label: 'Kota Domisili Saat Ini *',
        placeholder: 'Contoh: Jakarta',
      },
      willingToRelocate: {
        label: 'Bersedia Relokasi? *',
        placeholder: 'Pilih jawaban',
        options: [
          { value: 'Yes', label: 'Ya' },
          { value: 'No', label: 'Tidak' },
        ] as const,
      },
      status: {
        label: 'Status *',
        placeholder: 'Pilih status',
      },
    },
  },

  submit: {
    title: 'Review & Submit',
    summaryTitle: 'Ringkasan',
    labels: {
      cv: 'CV',
      fullName: 'Nama',
      emailAddress: 'Email',
      phoneNumber: 'Telepon',
      birthDate: 'Tanggal Lahir',
      targetedRoles: 'Role Diminati',
      expectedSalaryRange: 'Ekspektasi Gaji',
      currentCity: 'Kota Domisili',
      willingToRelocate: 'Bersedia Relokasi?',
      status: 'Status',
    },
    notFilled: 'Belum diisi',
    notSelected: 'Belum dipilih',
    loginButton: 'Login dengan Google untuk Submit',
    submitting: 'Mengirim...',
    privacyNote:
      'Data kamu aman. Kami hanya mengakses nama dan email untuk registrasi.',
  },

  thankYou: {
    heading: 'Kamu sudah terdaftar!',
    description:
      'Terima kasih, {name}. Kami sudah menerima data kamu. CV kamu sedang diproses oleh sistem kami.',
    whatsapp: {
      title: 'Gabung Komunitas',
      description:
        'Gabung grup WhatsApp untuk mendapatkan info lowongan terbaru dan tips karir.',
      cta: 'Gabung Grup WhatsApp',
    },
    dashboard: {
      title: 'Lihat Dashboard',
      description:
        'Cek status CV kamu dan kelola profil talent pool dari dashboard.',
      cta: 'Buka Dashboard',
    },
    nextSteps: {
      title: 'Langkah Selanjutnya',
      processing: {
        title: 'CV sedang diproses',
        description:
          'Sistem kami sedang menganalisis CV kamu. Proses ini biasanya memakan waktu beberapa menit.',
      },
      matching: {
        title: 'Talent matching aktif',
        description:
          'Setelah CV diproses, profil kamu akan aktif di talent pool dan bisa ditemukan oleh perusahaan partner.',
      },
    },
    support: 'Ada pertanyaan? Hubungi kami di hai@hyred.id',
  },

  footer: {
    copyright: '© 2026 PT Hyred Teknologi Indonesia. All rights reserved.',
    privacy: 'Privasi',
    terms: 'Syarat',
    contact: 'Kontak',
    exploreLabel: 'Jelajahi Hyred',
    links: [
      { href: '/id/talent-pool-pencari-kerja', label: 'Talent Pool untuk Pencari Kerja' },
      { href: '/id/cek-cv-ats', label: 'Cek CV ATS' },
      { href: '/id/review-cv-gratis', label: 'Review CV Gratis' },
      { href: '/id/template-cv-ats', label: 'Template CV ATS' },
      { href: '/id/mock-interview-adalah', label: 'Mock Interview' },
      { href: '/id/blog', label: 'Blog' },
    ],
    legalLinks: [
      { href: '/id/privacy', label: 'Privasi' },
      { href: '/id/terms', label: 'Syarat' },
      { href: '/id/contact', label: 'Kontak' },
    ],
  },

  common: {
    next: 'Lanjut',
    back: 'Kembali',
    freeTag: '100% Gratis buat talent',
  },

  validation: {
    required: 'Wajib diisi',
    fileRequired: 'Upload CV kamu terlebih dahulu',
    fileType: 'Hanya file PDF yang diperbolehkan',
    fileSize: 'Ukuran file maksimal 5MB',
    fullNameRequired: 'Nama lengkap wajib diisi',
    emailRequired: 'Email wajib diisi',
    emailInvalid: 'Email tidak valid',
    phoneRequired: 'Nomor telepon wajib diisi',
    birthDateRequired: 'Tanggal lahir wajib diisi',
    targetedRolesRequired: 'Tambahkan minimal satu role yang diminati',
    targetedRolesMax: 'Maksimal 3 role',
    salaryRequired: 'Ekspektasi gaji wajib diisi',
    currentCityRequired: 'Kota domisili wajib diisi',
    willingToRelocateRequired: 'Pilih kesediaan relokasi',
    statusRequired: 'Pilih status',
  },

  whatsappGroupUrl: 'https://chat.whatsapp.com/JFFcrqXmdzzATLzaZhDznA',
} as const
